import { Box } from "@mui/material";
import React from "react";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
export const ShareButton = () => {
  return (
    <Box className="share-button">
      <Box className="share-button-icn">
        <ShareOutlinedIcon sx={{ width: "20px", color: "var(--Main_icons_color)" }} />
      </Box>
      <Box className="share-button-text">
        <p>Share</p>
      </Box>
    </Box>
  );
};
